import * as React from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../hooks/useTheme';
import { Flex } from '../../common/Flex';
import { Icon } from '../../common/Icon';
import { Indent } from '../../common/Indent';
import { StyledText } from '../../common/StyledText';
import { IconBox } from '../../common/IconBox';

export const PartnerDashboardBlock = ({ icon, title, description }) => {
  const theme = useTheme();
  return (
    <Indent top={1.5} bottom={0} left={0} smRight={2}>
      <Flex align='center' wrap='nowrap'>
        <Indent right={0.8}>
          <IconBox>
            <Icon name={icon} width='1.5rem' color={theme.primaryColor} />
          </IconBox>
        </Indent>
        <h3>
          <Title>{title}</Title>
        </h3>
      </Flex>
      <Indent vertical={1} type='block'>
        <StyledText size={1.125} color='textSecondary' type='inlineBlock'>
          {description}
        </StyledText>
      </Indent>
    </Indent>
  );
};

const Title = styled.div`
  flex-basis: 100%;
  flex-shrink: 1;
  font-weight: 300;
  line-height: 28px;
  font-size: 1em;
  color: ${p => p.theme.textInvertedColor};
`;
